// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b64e2ee3","57":"5323eaaa","214":"956b39ba","234":"0beb1f9b","315":"4cdce280","375":"102d6e27","432":"651a78da","453":"a5aeb6a0","557":"292549a2","769":"e1661f8d","846":"bcce1c14","966":"0ebe2d0a"}[chunkId] + ".chunk.js";
};